import init from '../../helpers/init';

const {$, _} = init;
const BX = (<any>window).BX;

$(() => {

  const tableClass = '.js-uni-settings-lists';

  if ($(tableClass).length) {
    // таблица
    const uniSettingsTable = $(tableClass).DataTable({
      'language': (BX.message('LANGUAGE_ID') === 'en' ? {
        emptyTable: 'Missing data in the table',
        info: '_START_ - _END_ from _TOTAL_',
        infoEmpty: '0 from 0',
        infoFiltered: '(Filtered records of _MAX_)',
        infoPostFix: '',
        thousands: ',',
        lengthMenu: 'Elements per page _MENU_ ',
        loadingRecords: 'Loading...',
        processing: 'Loading...',
        search: 'Search:',
        zeroRecords: 'Not found',
        paginate: {
          first: 'First',
          last: 'Last',
          next: 'Next',
          previous: 'Previous'
        },
        aria: {
          sortAscending: ': activate the column to sort column ascending',
          sortDescending: ': activate the column to sort column descending',
          paginate: {
            first: 'First',
            last: 'Last',
            next: 'Next',
            previous: 'Previous'
          }
        }
      } : {
        emptyTable: 'Данные отсутствуют',
        info: '_START_ - _END_ из _TOTAL_',
        infoEmpty: '0 из 0',
        infoFiltered: '(Отфильтровано из _MAX_ записей)',
        infoPostFix: '',
        thousands: ',',
        lengthMenu: 'Выводить по _MENU_ ',
        loadingRecords: 'Загрузка...',
        processing: 'Загрузка...',
        search: 'Поиск: ',
        zeroRecords: 'Ничего не найдено',
        paginate: {
          first: 'Первый',
          last: 'Последний',
          next: 'Следующий',
          previous: 'Предыдущий'
        },
        aria: {
          sortAscending: ': активировать для сортировки столбца по возрастанию',
          sortDescending: ': активировать для сортировки столбца по убыванию',
          paginate: {
            first: 'Первый',
            last: 'Последний',
            next: 'Следующий',
            previous: 'Предыдущий'
          }
        }
      }),
      'columns': [
        {name: 'name', data: 'name', searchable: true, orderable: false, width: '20%'},
        {name: 'type', data: 'type', searchable: false, orderable: true, width: '10%'},
        {name: 'sort', data: 'sort', searchable: false, orderable: true, width: '5%'},
        {name: 'role', data: 'role', searchable: false, orderable: true, width: '5%'},
        {name: 'active', data: 'active', searchable: false, orderable: true, width: '1%'},
        {name: 'actions', data: 'actions', searchable: false, orderable: false, width: '5%'}
      ],
      'order': [[0, 'asc']],
      'lengthMenu': [
        [10, 20, 50, 100, 1000],
        [10, 20, 50, 100, (BX.message('LANGUAGE_ID') === 'en' ? 'All' : 'Все')]
      ],
      'processing': true,
      'serverSide': true,
      'stateSave': true,
      'stateDuration': -1,
      'ajax': {
        'url': (BX.message('LANGUAGE_ID') === 'en' ? '/local/ajax/office/UniSettings/listEn/' : '/local/ajax/office/UniSettings/listRu/'),
        'type': 'POST',
        'data': {
          'id': $(tableClass).data('id')
        }
      },
    });

    // удаление элемента
    $(tableClass).on('click', '.js-remove', (e: JQuery.ClickEvent) => {
      e.preventDefault();
      const apply = confirm(BX.message('LANGUAGE_ID') === 'en' ? 'Are you sure?' : 'Удаление элемента. Вы уверены?');
      if (apply) {
        const url = e.currentTarget.getAttribute('href');
        if (url !== null && url !== '') {
          $.ajax({
            method: 'GET',
            url: url,
            dataType: 'json'
          }).done(function (data) {
            console.log(data)
            if (data.result) {
              uniSettingsTable.ajax.reload();
            } else {
              alert(BX.message('LANGUAGE_ID') === 'en' ? 'Error!' : 'Ошибка!')
            }
          }).fail(function () {
            alert(BX.message('LANGUAGE_ID') === 'en' ? 'Request error!' : 'Ошибка запроса!');
          });
        }
      }

    });
  }

});
